import { ImageLoader } from "~/components/ImageLoader";
import { cn } from "~/lib/utils";
import { BlogPost, formatDate, urlFor } from "~/modules/blog/api/sanity";

// // // //

/**
 * AuthorByline
 * Larger byline used on the featured post and article header: an author avatar
 * with name/role on the left, and the publish date + read time on the right.
 */
export function AuthorByline(props: { post: BlogPost; className?: string }) {
    const { post, className } = props;
    const date = formatDate(post.publishedAt || post._createdAt);

    return (
        <div
            className={cn("flex items-center justify-between gap-4", className)}
        >
            <div className="flex items-center gap-3">
                {post.author?.image && (
                    <ImageLoader
                        src={urlFor(post.author.image)
                            .width(80)
                            .height(80)
                            .url()}
                        alt={post.author.name}
                        className="h-9 w-9 shrink-0 rounded-full bg-muted object-cover"
                    />
                )}
                {post.author?.name && (
                    <div className="leading-tight">
                        <div className="text-sm font-medium text-foreground">
                            {post.author.name}
                        </div>
                        {post.author.role && (
                            <div className="text-xs text-muted-foreground">
                                {post.author.role}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="flex shrink-0 items-center gap-3 text-sm">
                {post.readTime && (
                    <>
                        <span>{post.readTime}</span>
                        <span className="text-muted-foreground">|</span>
                    </>
                )}
                <span>{date}</span>
            </div>
        </div>
    );
}
